import { getGlobalMapRef } from "features/map/GlobalViewState"
import { tileLoadTracker } from "features/map/layers/cog/TrackedTileLayer"

export const waitForIdleMap = async () => {
    const map = getGlobalMapRef()?.current
    if (!map) return false

    await tileLoadTracker.waitForIdle()
    if (map.areTilesLoaded()) return true

    await new Promise((resolve) => map.once("idle", resolve))
    return true
}
